import {defineStore} from "pinia";
import {computed} from "vue";
import {useObservable} from "@vueuse/rxjs";
import {liveQuery} from "dexie";
import {db} from "@src/services/db";
import ChatSession from "@src/types/ChatSession";

const BOT_STATUS = ["bot", "gpt", "gemini", "paused", "advanced"];

export const useBotSessions = defineStore("botSessions", () => {
    const sessions = useObservable<ChatSession[]>(
        // @ts-ignore
        liveQuery(async () => {
            return db.sessions
                .where("status")
                .anyOf(BOT_STATUS)
                .reverse()
                .sortBy("updated_at");
        }),
        { initialValue: [] }
    );

    const status = computed(() => "success");

    return {
        sessions,
        status,
    };
});